import { createRoute } from './utils'

const apiRoutes = {
	activateAccount: createRoute('/api/activate-account/:id', {
		id: 'activate-account',
	}),
}

export default apiRoutes
